export default __webpack_public_path__ + "static/partner1-f55d638717fa9a43383d1cc43d42a396.jpg";